import { IdInterface } from '../../../core';

export class Id implements IdInterface {
    private _value?: string = undefined;

    static fromString(id?: string): IdInterface | undefined {
        if (id) {
            return new Id(id);
        }

        return undefined;
    }

    constructor(id: string) {
        this._value = String(id);
    }

    get value(): string | undefined {
        return this._value?.toUpperCase();
    }

    set value(value: string) {
        this._value = value;
    }

    equals(id: Id): boolean {
        return this.value === id?.value;
    }

    toString(): string {
        return this.value;
    }
}
